import React from 'react';
import { HelpCircle } from 'lucide-react';
import { TooltipContent, TooltipRoot, TooltipTrigger } from '@floraltech/ui';

/**
 * Icona con tooltip: il testo NON e' l'unica copia di un'informazione
 * necessaria, chiarisce un campo o un pulsante gia' etichettato (referto
 * dali I6, Task 10). Composta su TooltipRoot/Trigger/Content (non sul
 * wrapper <Tooltip>) per poter dare max-w-xs al contenuto: senza, un testo
 * lungo non va a capo in un riquadro leggibile.
 *
 * Promossa qui da ContrattoNuovo.tsx (P8, approvata dal controllore
 * 2026-08-03): serviva anche a ContrattiList e ContrattoDetail, e due copie
 * della stessa icona avrebbero potuto divergere nello stile al primo
 * ritocco.
 *
 * @param campo - alimenta un aria-label DISTINTO per ogni icona: "Aiuto"
 *   ripetuto N volte non dice quale campo apre.
 * @param testo - il contenuto del tooltip.
 */
const AiutoCampo: React.FC<{ campo: string; testo: string }> = ({ campo, testo }) => (
  <TooltipRoot>
    <TooltipTrigger asChild>
      <button
        type="button"
        className="inline-flex h-4 w-4 items-center justify-center rounded-sm text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-1"
        aria-label={`Aiuto: ${campo}`}
      >
        <HelpCircle className="h-3.5 w-3.5" />
      </button>
    </TooltipTrigger>
    <TooltipContent className="max-w-xs">{testo}</TooltipContent>
  </TooltipRoot>
);

export default AiutoCampo;
export { AiutoCampo };
